import { Axios } from 'axios';
import { injectable } from 'inversify';

import { Analytics } from '@vp/common/core/Analytics';
import { Failure, OperationResult, Success } from '@vp/common/core/OperationResult';
import { ErrorExtractor } from '@vp/common/data/ErrorExtractor';
import { AccessManagerRepository } from '@vp/manager/access/core/interface/AccessManagerRepository';
import { AccesssManagerDataMapper } from '@vp/manager/access/data/AccessManagerDataMapper';
import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';
import { ProfileResponseDto } from '@vp/profile/data/dto/ProfileResponseDto';
import { ProfileDataMapper } from '@vp/profile/data/ProfileDataMapper';

@injectable()
export class RestAccessManagerRepository implements AccessManagerRepository {
  constructor(
    private readonly http: Axios,
    private readonly errorExtractor: ErrorExtractor,
    private readonly analytics: Analytics,
    private readonly profileDataMapper: ProfileDataMapper,
    private readonly accesssManagerDataMapper: AccesssManagerDataMapper,
  ) {}

  async apply(
    id: string,
    changes: ProfileAccessModel,
    controller: AbortController = new AbortController(),
  ): Promise<OperationResult<ProfileAccessModel>> {
    try {
      const body = this.accesssManagerDataMapper.toPayloadDto(changes);

      const { data } = await this.http.put<ProfileResponseDto>(`/api/profiles/${id}`, body, { signal: controller.signal });
      const profile = this.profileDataMapper.toOwnerProfile(data);

      return Success.from(profile.access);
    } catch (error) {
      this.analytics.trackError(error);
      const message = this.errorExtractor.extract(error);
      return Failure.from(message);
    }
  }
}
